import { Fragment } from "react";
import type { z } from "zod/v4";
import { GameBall } from "@/components/images/game-ball";
import type { GameSchema } from "@/lib/schema";
import { getZodiac } from "@/utils/maskSix";
import {
  markSixBigSmall,
  markSixDoubleSingle,
  markSixHeDanShuang,
  markSixHeDaXiao,
  markSixSpecialBigSmall,
  markSixSpecialDoubleSingle,
  markSixSum,
  markSixWeiDaXiao,
} from "@/utils/result";

export function MarkSixDraw({
  gameData,
}: {
  gameData: z.infer<typeof GameSchema>;
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {gameData.result.map((item, index) => (
          <Fragment key={index}>
            {index === gameData.result.length - 1 && <span>+</span>}
            <div className="flex items-center gap-1">
              <GameBall gameType="1070" num={item} width={32} height={32} />

              <span>{getZodiac(item, gameData?.preTime ?? 0)}</span>
            </div>
          </Fragment>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-1">
          <span>总和</span>
          <span className="rounded-sm border px-2 py-1">
            {markSixSum(gameData.result)}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {markSixBigSmall(gameData.result)}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {markSixDoubleSingle(gameData.result)}
          </span>
        </div>

        <div className="flex items-center gap-1">
          <span>特码</span>
          <span className="rounded-sm border px-2 py-1">
            {markSixSpecialBigSmall(gameData.result)}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {markSixSpecialDoubleSingle(gameData.result)}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {markSixHeDaXiao(gameData.result)}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {markSixHeDanShuang(gameData.result)}
          </span>
          <span className="rounded-sm border px-2 py-1">
            {markSixWeiDaXiao(gameData.result)}
          </span>
        </div>
      </div>
    </div>
  );
}
